import { render, staticRenderFns } from "./messageLook.vue?vue&type=template&id=0d8f3bc6&scoped=true&"
import script from "./messageLook.vue?vue&type=script&lang=js&"
export * from "./messageLook.vue?vue&type=script&lang=js&"
import style0 from "./messageLook.vue?vue&type=style&index=0&id=0d8f3bc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f3bc6",
  null
  
)

export default component.exports